'use strict';
import * as $i_moment from "moment";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeCalendarPage$package$() {
  this.aoG = null;
  $n_Lmealorama_pages_RecipeCalendarPage$package$ = this;
  this.aoG = $i_moment.default;
}
export { $c_Lmealorama_pages_RecipeCalendarPage$package$ as $c_Lmealorama_pages_RecipeCalendarPage$package$ };
$p = $c_Lmealorama_pages_RecipeCalendarPage$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_RecipeCalendarPage$package$;
/** @constructor */
function $h_Lmealorama_pages_RecipeCalendarPage$package$() {
}
export { $h_Lmealorama_pages_RecipeCalendarPage$package$ as $h_Lmealorama_pages_RecipeCalendarPage$package$ };
$h_Lmealorama_pages_RecipeCalendarPage$package$.prototype = $p;
var $d_Lmealorama_pages_RecipeCalendarPage$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeCalendarPage$package$, "mealorama.pages.RecipeCalendarPage$package$", ({
  Lo: 1
}));
export { $d_Lmealorama_pages_RecipeCalendarPage$package$ as $d_Lmealorama_pages_RecipeCalendarPage$package$ };
var $n_Lmealorama_pages_RecipeCalendarPage$package$;
function $m_Lmealorama_pages_RecipeCalendarPage$package$() {
  if ((!$n_Lmealorama_pages_RecipeCalendarPage$package$)) {
    $n_Lmealorama_pages_RecipeCalendarPage$package$ = new $c_Lmealorama_pages_RecipeCalendarPage$package$();
  }
  return $n_Lmealorama_pages_RecipeCalendarPage$package$;
}
export { $m_Lmealorama_pages_RecipeCalendarPage$package$ as $m_Lmealorama_pages_RecipeCalendarPage$package$ };
//# sourceMappingURL=mealorama.pages.-Recipe-Calendar-Page$package$.js.map
